const CARD_HOLDER_ACTIONS = {
  PENDING: 'CARD_HOLDER_ACTIONS_PENDING',
  SUCCESS: 'CARD_HOLDER_ACTIONS_SUCCESS',
  FAILURE: 'CARD_HOLDER_ACTIONS_FAILURE',
  UPDATE_LIST: 'CARD_HOLDER_ACTIONS_UPDATE_LIST',
}

export const CARD_HOLDER_STATE = {
  REFRESHED: 'CARD_HOLDER_STATE_REFRESHED',
  IN_PROGRESS: 'CARD_HOLDER_STATE_IN_PROGRESS',
  SUCCESS: 'CARD_HOLDER_STATE_RETRIEVED',
  ERROR: 'CARD_HOLDER_STATE_ERROR',
  PENDING: 'CARD_HOLDER_STATE_PENDING',
}

export default CARD_HOLDER_ACTIONS
